<template>
	<div class="row" id="payment-form">
		<template  class="row  shadow-none" ref="form" >
			<div class="sa-frm-row mb-3">
				<div class="sa-form-control"  >
					<div class="sa-control" id="card-number"></div>
				</div>
			</div>
			<div class="sa-frm-row mb-3 pr-1" style="width:50%">
				<div class="sa-form-control"  >
					<div class="sa-control" id="card-expiry"></div>

				</div>
			</div>
			<div class="sa-frm-row mb-3 pl-1" style="width:50%">
				<div class="sa-form-control"  >
					<div class="sa-control" id="card-cvc"></div>

				</div>
			</div>
			<div class="sa-frm-row mb-3">
				<div class="sa-form-control" >
					<div class="sa-control"  id="card-zip"></div>
				</div>
			</div>
			<!-- <div v-if="emailErrorMessage" class="row shadow-none col-md-12">
				<div class="col-md-12 pr-0" style="color:red">{{'*'+emailErrorMessage}}</div>
			</div> -->
		</template>
		<!-- <template v-if="!isCardAddedSuccessfully">
			<div class="col-md-12 mt-3">
				<div class id="card-element"/>
			</div>
		</template> -->
		<template v-if="errorMessage" class="row shadow-none mb-3">
			<div class="col-md-12 pr-0" style="color:red">{{'*'+errorMessage}}</div>
		</template>
	</div>
</template>

<script>
import {demoNRDS, demoPersonId} from '@/properties'
	export default {
		name: "AddCard",
		components: {},
		data() {
			return {
				card: null,
				elements: null,
				cardCvv: 123,
				cardZip: 12345,
				cardNumber: 4242424242424242,
				cardExpiry: null,
				errorMessage: "",
				agentName:null,
				emailErrorMessage: "",
				valid: true,
				isCardAddedSuccessfully: false,
				requireRule: [v => !!v || "This field is required"],
				loading: false
			};
		},
		props: {},
		computed: {
			agentEmail:{
	            set(val){
	                this.agent.emails[0].email = val;
	            },
	            get(){
	                let email = null;
	                if (this.agent && this.agent.emails && this.agent.emails.length) {
	                    email = this.agent.emails[0].email;
	                }
	                return email;
	            }
	        },
	        agentAddress:{
	            set(val){
	                let workaddres = this.agent.addresses.filter((item)=>{
	                    return address.addressType == 'WORK';
	                });
	                workaddres = workaddres.length ? workaddres[0] : this.dummyAddress
	                workaddres = val;
	            },
	            get(){
	                let workaddres = null;
	                if (this.agent && this.agent.addresses && this.agent.addresses.length) {
	                    workaddres = this.agent.addresses.filter((item)=>{
	                        return item.addressType == 'WORK';
	                    });
	                    workaddres = workaddres.length ? workaddres[0] : this.dummyAddress
	                }
	                return workaddres;
	            }
	        },
			agent(){
				return this.$store.state.basicProfile
			}
		},
		methods: {
			submitForm() {
				this.personId = this.$route.params.personId
				this.personId = (this.personId == demoNRDS) ? demoPersonId : this.personId;
				let vm = this;
				this.loading = true;
				// if (this.personId == demoNRDS) {
	            //     setTimeout(()=>{
				// 		this.$router.push({
    		    //             path:'/summary'
    		    //         })
	            //     }, 100)
	            // }else {
	            // }
				vm.$store.dispatch("createStripeToken", {
					data: this.cardNumber
				})
				.then(function(data) {
					console.log({data});
					if (data.message) {
						vm.errorMessage = data.message;
					} else if (data.token) {
						vm.isCardAddedSuccessfully = true;
						vm.createCustomer(data["token"].id);
					}
					vm.loading = false;
					return null;
				});

			},
			getCookie(cname){
				var name = cname + "=";
				var ca = document.cookie.split(';');
				for(var i = 0; i < ca.length; i++) {
					var c = ca[i];
					while (c.charAt(0) == ' ') {
						c = c.substring(1);
					}
					if (c.indexOf(name) == 0) {
						return c.substring(name.length, c.length);
					}
				}
				return "";
			},
			createCustomer(stripeId){
				let vm = this;
				let payload = {};
				payload['sourceToken'] = stripeId;
				payload['spaceId'] = this.$store.state.spaceId; //parseInt(this.getCookie('spaceId'));
				payload['action'] = 'SAVE';
				payload['resourceType'] = 'PRINT-ORDER';
				payload['name'] = this.agentName;
				payload['email'] = this.agentEmail;
				vm.$store.dispatch("createCustomer", payload)
				.then(res => {
					vm.$router.push({
		                path:'/summary'
		            })
				});
			},
			goToWorbix(){
				this.$emit('setCookieAndLogin');
			},
			validateEmail(email){
	            const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	            return re.test(email);
	        },
			loadStripeElements(){
				// loading stripe elements to dom
				this.elements = this.$store.state.stripeObj.elements({
					fonts: [
						{
							cssSrc: 'https://fonts.googleapis.com/css?family=Source+Code+Pro',
						},
					],
				});

				var elementStyles = {
					base: {
						color: '#666',
						fontWeight: 500,
						fontFamily: 'Source Code Pro, Consolas, Menlo, monospace',
						fontSize: '15px',
						fontSmoothing: 'antialiased',
						'::placeholder': {
							color: '#666',
						},
						':-webkit-autofill': {
							color: '#e39f48',
						},
					},
					invalid: {
						color: '#E25950',
						'::placeholder': {
							color: '#FFCCA5',
						},
					},
				};

				var elementClasses = {
					focus: 'focused',
					empty: 'empty',
					invalid: 'invalid',
				};

				this.cardNumber = this.elements.create('cardNumber', {
					style: elementStyles,
					classes: elementClasses,
					placeholder:'CC Number'
				});
				this.cardNumber.mount('#card-number');

				this.cardExpiry = this.elements.create('cardExpiry', {
					style: elementStyles,
					classes: elementClasses,
					placeholder:'EXPIRATION'
				});
				this.cardExpiry.mount('#card-expiry');

				this.cardCvc = this.elements.create('cardCvc', {
					style: elementStyles,
					classes: elementClasses,
					placeholder:'CVV'
				});
				this.cardCvc.mount('#card-cvc');

				this.cardZip = this.elements.create('postalCode', {
					style: elementStyles,
					classes: elementClasses,
					placeholder:'Billing Zip'
				});
				this.cardZip.mount('#card-zip');

				[this.cardNumber, this.cardExpiry, this.cardCvc, this.cardZip].forEach((item, i) => {
					item.on('change', ()=>{
						console.log('changed');
						this.errorMessage = '';
					})
				});


			}
		},
		mounted() {

			this.loadStripeElements();

			if (this.agent && this.agent.name ) {
				this.agentName = this.agent.name.firstName + ' ' + this.agent.name.lastName;
			}

		}
	};
</script>

<style>
/* .card-number {
    border-bottom: 1px solid #989696de;
}

.StripeElement--focus {
    border-bottom: 2px solid #1976d2;
}

.StripeElement--invalid {
    border-bottom: 1px solid red;
} */
#card-element {
	border: 1px solid #ced4da;
	padding: 15px;
}
.onboarding-wrapper .ob-rightcol .state-agent #payment-form .sa-frm-row .sa-control{
	padding: 10px
}
</style>
